import React from "react";

function EnvelopeIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.80366 8.3533C2.52352 10.9562 2.53601 13.9582 2.92583 16.5505C3.14153 17.9849 4.3122 19.0845 5.75727 19.2102L7.2675 19.3414C10.4165 19.6152 13.5834 19.6152 16.7325 19.3414L18.2427 19.2102C19.6878 19.0845 20.8584 17.9849 21.0741 16.5505C21.4639 13.9582 21.4765 10.9564 21.1963 8.35345C21.1601 8.05169 21.1194 7.75034 21.0741 7.44949C20.8584 6.0151 19.6878 4.91545 18.2427 4.78983L16.7325 4.65855C13.5834 4.38481 10.4165 4.38481 7.2675 4.65855L5.75727 4.78983C4.3122 4.91545 3.14153 6.0151 2.92583 7.44949C2.8806 7.75028 2.83988 8.05159 2.80366 8.3533ZM7.3974 6.15292C10.46 5.88669 13.5399 5.88669 16.6025 6.15292L18.1128 6.2842C18.8671 6.34977 19.4782 6.92379 19.5908 7.67254C19.6025 7.7503 19.6139 7.82809 19.6249 7.90592L14.0639 10.9954C12.7803 11.7085 11.2196 11.7085 9.93596 10.9954L4.37502 7.90596C4.38608 7.82812 4.39746 7.75031 4.40915 7.67254C4.52175 6.92379 5.13284 6.34977 5.88717 6.2842L7.3974 6.15292ZM19.8085 9.51989C20.0025 11.7876 19.9299 14.0725 19.5908 16.3274C19.4782 17.0762 18.8671 17.6502 18.1128 17.7158L16.6026 17.8471C13.5399 18.1133 10.46 18.1133 7.3974 17.8471L5.88717 17.7158C5.13284 17.6502 4.52175 17.0762 4.40915 16.3274C4.07006 14.0725 3.9975 11.7877 4.19147 9.51992L9.20749 12.3066C10.9441 13.2714 13.0558 13.2714 14.7924 12.3066L19.8085 9.51989Z"
      />
    </svg>
  );
}

export default EnvelopeIcon;
